
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_55fkh_7smkg_10",
  "textarea-readonly": "awsui_textarea-readonly_55fkh_7smkg_55",
  "disabled": "awsui_disabled_55fkh_7smkg_61",
  "textarea-invalid": "awsui_textarea-invalid_55fkh_7smkg_69",
  "textarea-warning": "awsui_textarea-warning_55fkh_7smkg_97",
  "textarea": "awsui_textarea_55fkh_7smkg_55",
  "placeholder-visible": "awsui_placeholder-visible_55fkh_7smkg_192",
  "invalid": "awsui_invalid_55fkh_7smkg_228",
  "warning": "awsui_warning_55fkh_7smkg_228",
  "textarea-disabled": "awsui_textarea-disabled_55fkh_7smkg_231",
  "textarea-wrapper": "awsui_textarea-wrapper_55fkh_7smkg_248",
  "editable-wrapper": "awsui_editable-wrapper_55fkh_7smkg_253",
  "editable-element": "awsui_editable-element_55fkh_7smkg_259",
  "primary-action": "awsui_primary-action_55fkh_7smkg_266",
  "action-button": "awsui_action-button_55fkh_7smkg_274",
  "secondary-content": "awsui_secondary-content_55fkh_7smkg_279",
  "with-paddings": "awsui_with-paddings_55fkh_7smkg_314",
  "action-stripe": "awsui_action-stripe_55fkh_7smkg_324",
  "secondary-actions": "awsui_secondary-actions_55fkh_7smkg_363",
  "with-paddings-and-actions": "awsui_with-paddings-and-actions_55fkh_7smkg_381",
  "buffer": "awsui_buffer_55fkh_7smkg_385",
  "token-container": "awsui_token-container_55fkh_7smkg_391",
  "reference-wrapper": "awsui_reference-wrapper_55fkh_7smkg_399",
  "trigger-base": "awsui_trigger-base_55fkh_7smkg_403",
  "trigger-token": "awsui_trigger-token_55fkh_7smkg_407",
  "paragraph": "awsui_paragraph_55fkh_7smkg_413"
};
  